/*
 * File Created: Thursday, 11th May 2023 8:27:04 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { type Theme, useTheme } from "@mui/material";
import { CgArrowRight } from "react-icons/cg";
import React from "react";
import Input from "../Input/Input";
import Button from "../Button";
import { emailValidatorRegx, phoneNoValidatorRegx } from "../../constants/commom.constant";

function OrderForm() {
    const theme: Theme = useTheme();
    const [emailError, setEmailError] = React.useState("");
    const [phoneNoError, setPhoneNoError] = React.useState("");
    return (
      <React.Fragment>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            margin: theme.spacing(2)
            // gap: ,
          }}
        >
          <Typography variant="h5" fontWeight="500" textAlign="center">
            Add your address
          </Typography>
          <Typography variant="body1">Fill the form</Typography>
        </Box>
        <Box
          component="form"
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            console.log("onSubmit")
          }}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            padding: theme.spacing(1, 2),
          }}
        >
          {/* <FormC */}
          <Input
            variant="outlined"
            label="Full Name"
            type="text"
            required
            // helperText="HelperText"
            // fullWidth
          />
          <Input
            variant="outlined"
            label="Mobile No"
            type="tel"
            error={phoneNoError.length !== 0}
            helperText={phoneNoError}
            required
            onBlur={(e) => {
              if (!phoneNoValidatorRegx.test(e.target.value)) {
                setPhoneNoError("Enter a valid number");
              } else {
                setPhoneNoError("");
              }
            }}
            // fullWidth
          />
          <Input
            variant="outlined"
            type="email"
            label="Email"
            required
            error={emailError.length !== 0}
            helperText={emailError}
            onBlur={(e) => {
              if (!emailValidatorRegx.test(e.target.value)) {
                setEmailError("Enter a valid email")
              } else {
                setEmailError("");
              }
            }}
            // fullWidth
          />
          <Input
            variant="outlined"
            label="Address"
            // type="text"
            required
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 1,
            }}
          >
            <Input
              variant="outlined"
              label="Pincode"
              type="number"
              required
            />
            <Input
              variant="outlined"
              label="State"
              required
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: theme.spacing(2),
            }}
          >
            <Button
              title="Order Now"
              type="submit"
              endIcon={<CgArrowRight />}
            />
          </Box>
        </Box>
      </React.Fragment>
    );
  }

export default React.memo(OrderForm);